module.exports = __webpack_public_path__ + "static/img/timelineIcon.892cae46.svg";